import styles from './Content.module.scss';
import { Layout } from 'antd';

const { Content: ContentComponent } = Layout;

const Content = props => {
    return (
        <ContentComponent className={styles.content}>
            {props.children}
        </ContentComponent>
    );
};

export default Content;
